<template>
  <div>
    Něco se pokazilo
  </div>
</template>

<script>
export default {
  props: {
    error: { type: Object, required: true },
  },
}
</script>
